import { CSRF_TOKEN_NAME } from './ApplicationConfig';

const Cookies = require('js-cookie');

export default function getToken (id: string): string {
    let tokens = {};
    let data = Cookies.get(CSRF_TOKEN_NAME);
    
    if (typeof data === 'undefined') {
        return '';
    }

    data.split('|').forEach(part => {
        let pair = part.split('=');

        if (pair.length === 2) {
            tokens[pair[0]] = pair[1];
        }
    });

    return (id in tokens) ? tokens[id] : '';
}
